import React from 'react';

import { Label } from '@sopranodesign/pulse-components';
import { TemplatingTextArea } from '@sopranodesign/pulse-templating';

import { useComposer } from '../../../../hooks/index';

const ProgressInput = () => {
  const {
    response: { content },
    dispatch
  } = useComposer();

  const handleResponseChange = value => {
    dispatch({
      type: 'UPDATE_CONTENT',
      newContent: { text: value }
    });
  };

  return (
    <div>
      <Label htmlFor="standard">Message</Label>
      <TemplatingTextArea
        id="standard"
        name="standard"
        value={content.text}
        onChange={handleResponseChange}
      />
    </div>
  );
};

export default ProgressInput;
